<template>
<CModal @mtdclosemodal="mtdClose" :show.sync="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'xl'" :fullScreen="true" :btn_cancel="true" :btn_ok="true" :booTitile="true" :scrollable="true">
    <div class="row mx-0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row d-flex p-2">
                <div class="col-lg-4 col-md-12 mb-3">
                    <div class="card shadow">
                        <!-- <div class="card-header" style="background: #e1dedeb0">
                                <span><i class="fas fa-coins"></i> <strong>PRODUCTOS</strong></span>
                            </div> -->
                        <div class="card-body">
                            <div class="row d-flex">
                                <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                    <label for="fechaCompra">Fecha de Requerimiento</label>
                                    <input type="date" class="form-control mt-1" id="fechaCompra" v-model="cabezera.date">
                                </div>
                                <div class="col-md-12 mt-2">
                                    <label for="productoSelect">Producto</label>
                                    <v-select class="text-dark flex-grow-1 mt-1" label="name" :options="prodOptions" placeholder="Seleccione Producto" @search="mtdGetProd" v-model="purchase.selectedProd" :reduce="(name) => name.id" required :clearable="false">
                                        <template slot="no-options">
                                            No hay Productos para la busqueda
                                        </template>
                                    </v-select>
                                </div>
                                <div class="col-md-12 mt-2">
                                    <label for="cantidad">Cantidad</label>
                                    <input type="number" class="form-control mt-1" id="cantidad" placeholder="Cantidad" @input="validateQuantity" v-model="purchase.quantity" min="1">
                                </div>
                                <div class="col-12 d-flex justify-content-end mt-3">
                                    <button type="button" class="btn text-white" :disabled="!purchase.quantity" style="background: #57cc99" @click="mtdAddProd()">
                                        <i class="fas fa-plus"></i> Agregar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-12 mt-1">
                    <div class="card shadow">

                        <div class="card-header d-flex justify-content-start" style="background: #e1dedeb0">
                            <span><i class="fa fa-box-open"></i> <strong>LISTA DE PRODUCTOS</strong></span>
                        </div>
                        <div class="card-body">
                            <div class="row d-flex">
                                <div class="col-md-12 mt-2" id="content-timelinetable">
                                    <table id="tb-cxc" class="table table-bordered border-main" style="font-size: 13px">
                                        <caption class="py-0 my-0"></caption>
                                        <thead>
                                            <tr class="text-center text-white border-white bg-main align-middle">
                                                <th scope="col" class="table-th-number">N°</th>
                                                <th scope="col">PRODUCTO</th>
                                                <th scope="col" class="table-th-acciones">CANTIDAD</th>
                                                <th scope="col" class="table-th-acciones">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in  cabezera.data" :key="item.id" class="text-center align-middle">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ item.nameProd }}</td>
                                                <td>{{ item.quantity }}</td>
                                                <td><button type="button" @click="mtdDeleteProd(item.id)" class="btn btn-danger btn-sm px-1 py-0"><i class="fas fa-trash-alt text-white"></i></button></td>
                                            </tr>
                                            <tr class="text-center" v-if="cabezera.data.length == 0">
                                                <td colspan="4">Aun no hay productos seleccionados</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-info text-white" :disabled="isDisabled" @click="register()">
                                        <i class="fas fa-save"></i> Guardar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

import {
    mapActions
} from "vuex";
export default {
    name: "c-logistica-cModalRequerimiento",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            prodOptions: [],
            purchase: {
                id: null,
                quantity: null,
                selectedProd: "",
                nameProd: "",
            },
            cabezera: {
                campu_id: "",
                date: "",
                serie: "",
                data: [],
            },
        };
    },
    created() {

    },
    computed: {
        isDisabled() {
            return !this.cabezera.date ||
                this.cabezera.data.length === 0;
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdClose(opt) {
            this.$emit("closeModal",opt);
        },
        mtdAddProd: function () {
            const selectedProduct = this.prodOptions.find(product => product.id === this.purchase.selectedProd);
            if (selectedProduct) {
                this.purchase.nameProd = selectedProduct.name;
            } else {
                this.purchase.nameProd = "";
            }
            this.purchase.id = this.cabezera.data.length + 1;
            this.cabezera.data.push(this.purchase);
            this.purchase = {
                id: null,
                price: null,
                quantity: null,
                selectedProd: "",
                nameProd: "",
            }
            this.prodOptions = [];
        },
        validateQuantity(event) {
            let value = parseInt(event.target.value);
            if (value < 1 || isNaN(value)) {
                event.target.value = 1;
                this.purchase.quantity = 1;
            } else {
                this.purchase.quantity = value;
            }
        },

        mtdGetProd: function (search, loading) {
            let campu_id = this.$store.getters.get__campus;
            if (search.length > 2) {
                this.prodOptions = [];
                this.purchase.selectedProd = "",
                    loading(true);
                this.get({
                        url: this.$store.getters.get__url + "/Logis/purchase/product/" + search + "/" + campu_id,
                        token: this.$store.getters.get__token,
                    })
                    .then((response) => {
                        this.prodOptions = response.data;
                        loading(false);
                    })
                    .catch((errors) => {
                        this.$refs.SweetAlert.showError(errors);
                    });
            }
        },
        mtdDeleteProd: function (id) {
            this.$refs.SweetAlert.showConfirmSimple2("", "¿Estás seguro eliminar este Producto?", "warning", "Eliminar")
                .then((result) => {
                    if (result.value) {
                        const indice = this.cabezera.data.findIndex(item => item.id === id);
                        if (indice !== -1) {
                            this.cabezera.data.splice(indice, 1);
                            this.purchase = {
                                id: null,
                                price: null,
                                quantity: null,
                                subtotal: null,
                                selectedProd: "",
                                nameProd: "",
                            }
                        }
                    }
                });
        },
        register: function () {
            this.$refs.SweetAlert.showConfirmSimple2("", "¿Estás seguro de registrar este requerimiento?", "warning", "Registrar")
                .then((result) => {
                    if (result.value) {
                        this.cabezera.campu_id = this.$store.getters.get__campus;
                        this.post({
                                url: this.$store.getters.get__url + "/Logis/requirement/store",
                                token: this.$store.getters.get__token,
                                params: this.cabezera,
                            })
                            .then((response) => {
                                if (response.statusCode == 200) {
                                    this.$refs.SweetAlert.showSuccess("Requerimiento Registrado Correctamente");
                                    //cerrar moda
                                    this.mtdClose(0);
                              
                                }
                            })
                            .catch((errors) => {
                                this.$refs.SweetAlert.showError(errors);
                            });
                    }
                });
        },
    },
};
</script>
